import { render } from "./IconBook.vue?vue&type=template&id=926edfd0"
const script = {}

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/icon/IconBook.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "926edfd0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('926edfd0', __exports__)) {
    api.reload('926edfd0', __exports__)
  }
  
  module.hot.accept("./IconBook.vue?vue&type=template&id=926edfd0", () => {
    api.rerender('926edfd0', render)
  })

}


export default __exports__